<template>
  <div class="LeaseList">
    <template v-if="formData.showMode === 'CARD'"> 
    <!-- 竞价 -->
    <div class="tenderList" v-if="formData.queryPosition === 8">
      <BiddingList :list="tenderList" @goTo="goDetail"></BiddingList>
      <div class="dis-fl fw-w" v-if="isShowSkeleton && !tenderList.length && loading">
        <comTMBSke
          v-for="(item,index) in new Array(10)"
          :key="index"
          style="margin-bottom: 20px;margin-left:20px"
        />
      </div>
    </div>
    <!-- 需求预告 -->
    <div v-if="formData.queryPosition === 20">
      <ZbDemandList
        :zbDemandList="tenderList"
        :loading="loading"
      ></ZbDemandList>
      <div class="dis-fl fw-w" v-if="isShowSkeleton && !tenderList.length && loading">
        <comTMBSke
          v-for="(item,index) in new Array(10)"
          :key="index"
          style="margin-bottom: 20px;margin-left:20px"
        />
      </div>
    </div>
    <!-- 招标预告 -->
    <div v-if="formData.queryPosition === 13" class="tenderList">
      <ul style="padding-left:20px;">
        <TenderItemAdvance
          v-for="(item,index) in tenderList"
          :key="index"
          :item="item"
          :index="index"
          :type="2"
        ></TenderItemAdvance>
      </ul>
      <div class="dis-fl fw-w" v-if="isShowSkeleton && !tenderList.length && loading">
        <comTMBSke
          v-for="(item,index) in new Array(10)"
          :key="index"
          style="margin-bottom: 20px;margin-left:20px"
        />
      </div>
    </div>
    <!-- 不限 招标公告 -->
    <div class="tenderList" v-if="formData.queryPosition === 23 || formData.queryPosition === 4">
      <ul style="padding-left:20px;">
        <!-- 劳务和机械的列表 -->
        <TenderItem
          v-for="(item, index) in tenderList"
          :key="index"
          :item="item"
          :index="index"
          @inByLetDialogClick="inByLetDialogClick"
        ></TenderItem>
      </ul>
      <div class="dis-fl fw-w" v-if="isShowSkeleton && !tenderList.length && loading">
        <comTMBSke
          v-for="(item,index) in new Array(10)"
          :key="index"
          style="margin-bottom: 20px;margin-left:20px"
        />
      </div>
    </div>
    </template>

    <!-- 列表 -->
    <div class="tenderList" v-if="formData.showMode === 'TABLE'">
      <div class="tableListHead">
        <div style="width: 303px;padding-left:35px">招标名称</div>
        <div style="width: 314px;padding-left:35px">采购单位</div>
        <div style="width: 160px;padding-left:35px">预算金额</div>
        <div style="width: 170px;padding-left:35px">投标人限定</div>
        <div style="width: 250px;padding-left:35px">时间</div>
      </div>
      <ul>
          <li
            class="list"
            v-for="(item, index) in tenderList"
            :class="{ line: index == jShow }"
            @mouseenter="jMover(index)"
            @mouseleave="jShow = -1"
            :key="item.id"
          >
            <img class="leftHead" v-if="item.state === 1" src="../../../assets/jjzb1.png" alt />
            <img
              class="leftHead"
              v-if="item.state === 2 || item.state === 6"
              src="../../../assets/zzzb1.png"
              alt
            />
            <img class="leftHead" v-if="item.state === 3" src="../../../assets/jbpb1.png" alt />
            <img class="leftHead" v-if="item.state === 4" src="../../../assets/zbdb1.png" alt />
            <img class="leftHead" v-if="item.state === 8" src="../../../assets/zbyg1.png" alt />
            <img class="leftHead" v-if="item.state === 9" src="../../../assets/zbbm1.png" alt />
            <div class="item" style="width: 230px;" @click="goNewDetail(item.id, item)">
              <div class="titleName">
                <span class="proName">
                  <span
                    class="dataSourceTag"
                    v-if="item.dataSources && item.dataSources !== 2"
                  >{{item.dataSourcesName}}</span>
                  {{ item.name }}
                </span>
              </div>
              <div class="blues">
                <span
                  style="color: #78c06e;"
                  v-if="item.qualificationWayName"
                >【{{ item.qualificationWayName }}】</span>
                <span
                  style="color: #0286df"
                  v-if="item.state !== 9 && item.rotation"
                >【第{{ item.rotation }}轮】</span>
                【{{ item.type | tenderType }}】
              </div>
            </div>
            <div class="item item-name" style="width: 270px;" @click="goNewDetail(item.id, item)">
              <div
                class="titleName1"
                style="color: #0286DF;"
                @click.stop="toCompany(item.comNo)"
              >{{ item.comName }}</div>
              <div class="titleName1" style="color: #333333;">地址：{{ item.fullAddress }}</div>
            </div>
            <div class="item" style="padding:0 40px 0 20px" @click="goNewDetail(item.id, item)">
              <div class="titleName2">
                <span
                  v-if="item.money"
                  class="moeny"
                  :title="item.money + '元'"
                >{{ getMoney(item.money) }}</span>
              </div>
            </div>
            <div class="item" style="width: 150px;">
              <div class="titleName3" v-if="item.biddingMethod == 2">
                <span style="color: #FF6600;" class="el-icon-user-solid">
                  {{
                  item.biddingMethodName
                  }}
                </span>
              </div>
              <div
                class="titleName3"
                v-else-if="item.bidderRuleList && item.bidderRuleList.length > 0"
              >
                <p class="areaBox" v-for="(x, i) in item.bidderRuleList" :key="i">{{ x }}</p>
              </div>
              <div v-else>
                <span style="color: #FF6600;">公开</span>
              </div>
            </div>
            <!-- 经营帮的数据显示下面的时间 -->
            <div class="item" style="width: 230px;border: none;" v-if="item.dataSources === 1">
              <template v-if="(item.state == 1 || item.state == 2) && item.bidStartTime">
                <div class="titleName4">投标开始-截止时间</div>
                <div class="titleName4">{{ Number(item.bidStartTime) | formaHoures }}</div>
                <div class="titleName4" style="text-align: center;width:110px">-</div>
                <div class="titleName4">{{ Number(item.bidEndTime) | formaHoures }}</div>
              </template>
              <template v-if="(item.state == 8 || item.state == 9) && item.applyStartTime">
                <div class="titleName4">报名开始-截止时间</div>
                <div class="titleName4">{{ Number(item.applyStartTime) | formaHoures }}</div>
                <div class="titleName4" style="text-align: center;width:110px">-</div>
                <div class="titleName4">{{ Number(item.applyEndTime) | formaHoures }}</div>
              </template>
              <template v-if="item.state == 3 && item.openBidTime">
                <div class="titleName4">开标时间</div>
                <div class="titleName4">{{ Number(item.openBidTime) | formaHoures }}</div>
              </template>
              <template v-if="item.state == 4 && item.calibrationTime">
                <div class="titleName4">定标时间</div>
                <div class="titleName4">{{ Number(item.calibrationTime) | formaHoures }}</div>
              </template>
            </div>
            <!-- 商机爬虫的数据显示下面的时间 -->
            <div class="item" style="width: 230px;border: none;" v-if="item.dataSources === 2">
              <!-- 正在招标时间 -->
              <template v-if="(item.state == 1 || item.state == 2) && item.bidStartTime">
                <div class="titleName4">文件递交开始-截止时间</div>
                <div class="titleName4">{{ Number(item.bidStartTime) | formaHoures }}</div>
                <div class="titleName4" style="text-align: center;width:110px">-</div>
                <div class="titleName4">{{ Number(item.bidEndTime) | formaHoures }}</div>
              </template>
              <!-- 招标报名时间 -->
              <template v-if="(item.state == 8 || item.state == 9) && item.applyStartTime">
                <div class="titleName4">文件获取开始-截止时间</div>
                <div class="titleName4">{{ Number(item.applyStartTime) | formaHoures }}</div>
                <div class="titleName4" style="text-align: center;width:110px">-</div>
                <div class="titleName4">{{ Number(item.applyEndTime) | formaHoures }}</div>
              </template>
              <!-- 招标定标时间 -->
              <template v-if="item.state == 3 && item.calibrationTime">
                <div class="titleName4">定标时间</div>
                <div class="titleName4">{{ Number(item.calibrationTime) | formaHoures }}</div>
              </template>
            </div>

            <jPop
              v-if="index == jShow"
              :type="1"
              :item="item"
              @go="goNewDetail(item.id, item)"
              :jIndex="index"
              @inByLetDialogClick="inByLetDialogClick"
            ></jPop>
          </li>
        <BaseEmptyData v-if="tenderList.length === 0 && !loading" style="margin-bottom:93px" />
      </ul>
    </div>
    <!-- 缺省页 -->
    <BaseEmptyData v-if="tenderList &&  tenderList.length === 0 && !loading" style="margin-bottom:93px" />
    <infinite-scroll v-show="page.pageNum !== 1" :loadMoreFn="loadMoreFn" :hasMore="hasMore" :threshold="300" :doing="loading" />
    <!-- 函询 -->
    <InByLetDialog
      ref="InBylet"
      :dialogVisible="inByLetDialogShow"
      :dialogType="0"
      :typeData="typeData"
      @closeDialog="closeinDialog"
      @confirmDialog="confirminDialog"
    ></InByLetDialog>
  </div>
</template>
<script>
import axios from "@/http/zhaocai";
import link from "@/public/link.js";
import apiIln from "@/api/zhaocai/apiLnquiryLetter.js";
import comTMBSke from '@/components/zhaocai/skeComponents/comTMBSke'
export default {
  name: "LeaseList",
  components: {
    Pagination: () => import("@/views/hotTender/components/Pagination"),
    BiddingList: () => import("./bidList.vue"),
    jPop: () => import("@/components/zhaocai/jPop"),
    InByLetDialog: () => import("@/components/zhaocai/InquiryLetterDialog"),
    TenderItem: () => import("./TenderItem"),
    TenderItemAdvance: () =>
      import("@/views/hotTender/components/TenderItemAdvance"),
    ZbDemandList: () => import("@/views/hotTender/components/zbDemandList.vue"),
    comTMBSke,
    // 底部加载组建
    InfiniteScroll: () => import('@/components/zhaocai/infiniteScroll.vue'),
    BaseEmptyData: () => import("@/components/public/BaseEmptyData"),
  },
  data() {
    return {
      isShowSkeleton: true, // 骨架屏控制
      // 控制函询dialog显示隐藏
      jMarkId: "",
      typeData: [],
      inByLetDialogShow: false,
      jShow: -1,
      loading: true,
      icon_nodata: require("@/assets/icon_nodata.png"),
      tenderList: [], // 招投标列表
      page: {
        pageNum: 1, // 当前页
      },
      hasMore: false,
      pageMachineLabor: {
        selectType: 1,
        limit: 20,
        page: 1,
        total: 0,
        type: null,
        city: "", // 市
        name: "", // 招标名称
        state: "", // 招标状态
        sortMethod: "1",
        keyword: "",
        queryPosition: 23, // 对应调取位置
        dataSources: 0, // 数据来源
        qualificationWay: 0 // 资格审查方式
      },
    };
  },
  props: {
    // 列表入参
    formData: {
      type: Object,
      default: () => ({})
    },
    // propsObj: {
    //   type: Object,
    //   required: true
    // }
  },
  mounted() {
  },
  methods: {
    governmentOrder() {

    },
    // 函询
    async inByLetDialogClick(e, s, obj) {
      if (this.$store.state.loginType) {
        let res = {};
        if (s === 0) {
          res = await apiIln.getCheckAllowBidQuestion(e);
        } else {
          res = await apiIln.getCheckAllowTenderQuestion(e);
        }

        if (res.data.code === 0) {
          this.getTenderReceiverInquiry(obj.type);
          this.jMarkId = e;
          this.$emit("jMover", this.jIndex);
          this.inByLetDialogShow = true;
        } else {
          this.$message.error(res.data.msg);
        }
      } else {
        // 没有登录
        this.$store.commit("SET_LOGINDIALOG", true);
        return false;
      }
    },
    async getTenderReceiverInquiry(type) {
      let pararms = {
        tenderingType: type
      };
      let { data } = await apiIln.getTenderReceiverInquiry(pararms);
      if (data.code === 0) {
        this.typeData = data.result;
      }
    },
    // 函询dialog关闭方法
    closeinDialog(val) {
      this.inByLetDialogShow = val;
    },
    async confirminDialog(obj, cab) {
      let data = { markId: this.jMarkId, ...obj };
      let res = await apiIln.getSaveForTender(data);
      if (res.data.code === 0) {
        this.$message.success(res.data.msg);
        this.inByLetDialogShow = false;
      } else {
        this.$message.error(res.data.msg);
      }
      cab();
    },
    jMover(i) {
      this.jShow = i;
    },
    getMoney(val) {
      if (val >= 10000) {
        return (val / 10000).toString().match(/^\d+(?:\.\d{0,2})?/) + "万元";
      } else {
        return val + "元";
      }
    },

    getColor(val) {
      let color = "";
      switch (val) {
        case 3:
          color = "#969696";
          break;
        case 8:
          color = "#969696";
          break;
        case 9:
          color = "#409EE9";
          break;
        case 10:
          color = "#F7AB01";
          break;
        default:
          color = "#78C06E";
          break;
      }
      return color;
    },
    // 详情跳转
    goDetail(no, typeName) {
      if (typeName === "机械设备租赁") {
        typeName = "机械/设备";
      }
      if (this.formData.queryPosition === 8) {
        // 动态竞价
        window.open("/CompeteBiddingDetail?no=" + no + "&typeName=" + typeName);
      } else {
        window.open("/hotTenderDetail?no=" + no + "&typeName=" + typeName);
      }
    },
    goNewDetail(no, obj = {}) {
      if (this.formData.queryPosition === 8) {
        // 动态竞价
        window.open(`/CompeteBiddingDetail?no=${no}`);
      } else {
        if (obj.dataSources === 2) {
          let url = `/tenderDetails?id=${obj.id}`;
          window.open(url);
        } else {
          if (obj.state === 8) {
            window.open("/biddingDetail?id=" + obj.id);
          } else {
            window.open(`/hotTenderMachineLaborDetail?no=${no}`);
          }
        }
      }
    },
    toCompany(no) {
      link.materialsShopUrl(no, 10);
    },
    /* 获取企业列表 */
    // getData(val) {
    //   let data = val;
    //   this.isShowSkeleton = data === 1
    //   this.loading = true;
    //   axios
    //     .get("/api/font/getTenderList", data)
    //     .then(res => {
    //       this.loading = false;
    //       this.tenderList = this.tenderList.concat(res.data.list) || [];
    //       this.hasMore = !!res.data.list.length
    //     })
    //     .catch(err => {
    //       console.log(err);
    //       this.loading = false;
    //     });
    // },
    // 加载数据
    loadMoreFn() {
      this.page.pageNum++
      this.getMachineLaborList()
      return Promise.resolve(false)
    },
    // 判断类型如果是劳务或者机械就走这个请求
    getMachineLaborList() {
      this.loading = true;
      this.isShowSkeleton = this.page.pageNum === 1
      const params = {
        ...this.formData,
        page: this.page.pageNum
      }
      axios
        .post('/ov1/tender/es/queryHomeEsPage', params)
        .then(res => {
          this.loading = false;
          this.tenderList = [...this.tenderList, ...res.data.result]
          this.hasMore = !!res.data.result.length
        })
        .catch(err => {
          this.loading = false;
        });
    }
  },
  watch: {
    formData: {
      handler(newData) {
        if(Object.keys(newData).length) {
          this.tenderList = []
          this.page.pageNum = newData.page
          this.getMachineLaborList()
        }
      },
      deep: true,
      immediate: true
    },
    // propsObj: {
    //   handler(newObj, oldObj) {
    //     // 筛选条件改变-重置数据
    //     // this.restReqData()
    //     // 判断如果是劳务和机械走这个请求
    //     console.log(newObj,'newObj.default-=-=-=-=-=');
    //     if (newObj.default === "newQuestion") {
    //       this.IsMachineLabor = true;
    //       this.pageMachineLabor.type = newObj.tenderTypeShow.no;
    //       this.pageMachineLabor.province = newObj.areaListShow.no;
    //       this.pageMachineLabor.verticalType = newObj.qualificationWayShow.no;
    //       this.pageMachineLabor.goodsType = newObj.projeCateShow.no;
    //       this.pageMachineLabor.goodsTypeNo = newObj.projeCateShow.no;
    //       if (newObj.timeListShow) {
    //         // 时间
    //         this.pageMachineLabor.applyEndTime = newObj.timeListShow.no;
    //         this.pageMachineLabor.time = newObj.timeListShow.no;
    //       }
    //       if (newObj.priceListShow) {
    //         // 金额
    //         this.pageMachineLabor.price = newObj.priceListShow.no;
    //       }
    //       if (newObj.tenderStatusShow) {
    //         // 状态
    //         this.pageMachineLabor.state = newObj.tenderStatusShow.no;
    //       }
    //       // 招标方式
    //       if (newObj.biddingMethodShow) {
    //         this.pageMachineLabor.biddingMethod = newObj.biddingMethodShow.no;
    //       }
    //       // 数据来源
    //       if (newObj.dataSourceShow) {
    //         if(!newObj.tenderFromShow.no || newObj.tenderFromShow.no == 1) {
    //           this.pageMachineLabor.dataSources = newObj.dataSourceShow.no;
    //         } else {
    //           this.pageMachineLabor.dataSources = 0
    //         }
    //       }
    //       // 资格审查方式
    //       if (newObj.qualificationWayShow) {
    //         this.pageMachineLabor.qualificationWay =
    //           newObj.qualificationWayShow.no;
    //       }
    //       // 搜索的   竞价用的是cityNo
    //       this.pageMachineLabor["name"] = newObj.searchData.searchName;
    //       if (this.typeStr === "direct-jb") {
    //         this.pageMachineLabor["companyName"] =
    //           newObj.searchData.companyName;
    //         this.pageMachineLabor.cityNo = newObj.listShow.no;
    //         // 新版es省市区用city字段
    //         this.pageMachineLabor.city = newObj.listShow.no;
    //       } else {
    //         this.pageMachineLabor["comName"] = newObj.searchData.companyName;
    //         this.pageMachineLabor.city = newObj.listShow.no;
    //       }
    //       if (newObj.sortMethod) {
    //         this.pageMachineLabor.sortMethod = newObj.sortMethod;
    //       }
    //       this.pageMachineLabor["keyword"] = newObj.searchData.keyword;
    //       if (newObj.landUseShow) {
    //         this.pageMachineLabor.use = newObj.landUseShow.no;
    //       }
    //       if (newObj.cargoTypeListShow) {
    //         this.pageMachineLabor.typeName = newObj.cargoTypeListShow.no;
    //       }
    //       if (newObj.carTypeByGoodsTypeShow) {
    //         this.pageMachineLabor.motorcycleType =
    //           newObj.carTypeByGoodsTypeShow.name;
    //       }
    //       this.pageMachineLabor.page = 1;
    //       // if (this.typeStr !== "demand") {
    //       //   !this.loading && this.getMachineLaborList();
    //       // }
    //       // this.getMachineLaborList();
    //     } else {
    //       try {
    //         this.IsMachineLabor = false;
    //         this.page.city = newObj.listShow.no;
    //         this.page.areacode = newObj.areaListShow.no;
    //         this.page.type = newObj.tenderTypeShow.no;
    //         this.page.priceNo = newObj.priceListShow.no;
    //         this.page.status = newObj.tenderStatusShow.no;
    //         this.page.goodsType = newObj.projeCateShow.no;
    //         this.page.goodsTypeNo = newObj.projeCateShow.no;
    //         this.page.pageNum = 1;
    //         this.page.total = 0;
    //         if (newObj.biddingMethodShow) {
    //           this.page.biddingMethod = newObj.biddingMethodShow.no;
    //         }
    //         // 搜索的
    //         this.page["name"] = newObj.searchData.searchName;
    //         this.page["comName"] = newObj.searchData.comName;
    //         this.page["keyword"] = newObj.searchData.keyword;
    //         if (newObj.sortMethod) {
    //           this.page.sortMethod = newObj.sortMethod;
    //         }
    //         // this.getData(this.page);
    //       } catch (err) {}
    //     }
    //   },
    //   deep: true,
    //   immediate: true
    // },
  }
};
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
.line {
  border: 1px solid #b79255 !important;
}
/* 面包屑 */
.LeaseList {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
  background-color: #fff;
}
.tc_10 {
  height: 10px;
}
.tc_20 {
  height: 20px;
}

.tenderList {
  border-left: 1px solid #e4e7ed;
  border-right: 1px solid #e4e7ed;
  border-bottom: 1px solid #e4e7ed;
  padding-top: 20px;
  .tableListHead {
    background: #f5f7fa;
    display: flex;
    height: 44px;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
    border: 1px solid #e4e7ed;
  }
  ul {
    display: flex;
    flex-wrap: wrap;
    background-color: #fff;
    border-top: 0px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    .list {
      width: 100%;
      background-color: #fff;
      border-bottom: 1px solid #dfe4ea;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      position: relative;
      font-size: 14px;
      overflow: hidden;
      padding: 10px;
      z-index: 1;
      .leftHead {
        position: absolute;
        top: 0;
        left: 0;
        .blue {
          background-color: #409ee9;
        }
      }
      .item {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        padding: 0px 30px;
        margin: 10px 0px;
        border-right: 1px solid #e4e7ed;
        .titleName {
          width: 230px;
          line-height: 24px;
          color: #333333;
          display: -webkit-box;

          box-sizing: border-box;
          .proName {
            display: inline-block;
            width: 100%;
            word-break: break-all;
            padding-left: 6px;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            .dataSourceTag {
              background: linear-gradient(90deg, #f17658 0%, #df361b 100%);
              color: #fff;
              font-size: 12px;
              width: 48px;
              height: 20px;
              padding: 3px;
            }
          }
        }
        .titleName1 {
          width: 254px;
          height: 26px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .titleName2 {
          width: 100px;
          color: #333333;
        }
        .titleName3 {
          color: #333333;
          .areaBox {
            line-height: 24px;
            color: #333333;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
        }
        .titleName4 {
          width: 150px;
          color: #333333;
        }
      }
      .item-name {
        flex-direction: column;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .menu {
      width: 275px;
      background-color: #fff;
      border: 1px solid #e4e7ed;
      margin-top: 25px;
      margin-left: 20px;
      cursor: pointer;
      height: 243px;

      &:hover {
        border-bottom: none;
        transform: translateY(-19px);
        transition: all 0.2s ease-in-out;
      }
      .head {
        height: 70px;
        background-color: #f5f7fa;
        position: relative;
        border-bottom: 1px solid #e4e7ed;
        overflow: hidden;
        p {
          width: 220px;
          height: 50px;
          line-height: 25px;
          padding-top: 10px;
          margin-left: 10px;
          font-size: 16px;
          color: #333;
          font-weight: normal;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
        .i-status {
          display: block;
          position: absolute;
          top: 9px;
          right: -25px;
          font-size: 12px;
          color: #fff;
          background-color: #999;
          width: 90px;
          height: 24px;
          line-height: 24px;
          text-align: center;
          transform: rotate(45deg);
          transform-origin: (0, 0);
        }
        .blue {
          background-color: #409ee9;
        }
      }
      .body {
        padding: 15px 12px;
        font-size: 14px;
        .badge {
          white-space: nowrap;
          span {
            font-size: 13px;
            display: inline-block;
            &:first-child {
              color: #ff6600;
            }
          }
        }
        .end-time {
          color: #666;
          margin-top: 12px;
          span {
            color: #969696;
          }
        }
        .company {
          margin-top: 12px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #0286df;
          span {
            color: #666;
          }
        }
        .address {
          margin-top: 12px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #969696;
          span {
            color: #666;
          }
        }
      }
    }
  }
}
.jBtn3_more {
  text-align: center;
  font-size: 14px;
  color: #ffffff;
  div {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    line-height: 40px;
    img {
      margin-right: 10px;
    }
  }
}
.noData {
  text-align: center;
  img {
    display: block;
    width: 200px;
    margin: 10px auto;
  }
  span {
    font-size: 16px;
  }
}
.loading {
  color: #0286df;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
  i {
    font-size: 40px;
  }
}
.label {
  color: #333333;
}
.blues {
  color: #ff6600;
  margin-top: 10px;
}
.guanzhu {
  line-height: 64px;
  color: #333333;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  img {
    width: 18px;
    height: 16px;
  }
  span {
    margin-left: 10px;
  }
}

.el-pager li.active {
  color: #b79255;
}
.tc_25 {
  width: 1198px;
  height: 25px;
  border-left: 1px solid #e4e7ed;
  border-right: 1px solid #e4e7ed;
}
/deep/ .el-table__header .cell {
  text-align: left;
}
</style>
